/* Bounded settlement scheduler. Authorization is supplied by the private launch boundary. */
(function(root,factory){if(typeof module==='object'&&module.exports)module.exports=factory();else root.NikuyaCartAutomatic=factory()})(globalThis,function(){
 'use strict';
 function create({isAuthorized,settle,onResult=()=>{},schedule=fn=>setTimeout(fn,0)}={}){
  let running=false,queued=false,dirty=false,stopped=false;
  const allowed=()=>{try{return isAuthorized?.()===true}catch(_){return false}};
  async function drain(){
   queued=false;if(running||stopped||!allowed())return;
   running=true;dirty=false;
   try{const result=await settle();if(!['SETTLED','NO_CONTEXT','EMPTY','DISABLED'].includes(result?.status))stopped=true;onResult(result)}
   catch(_){stopped=true;onResult({status:'BLOCKED',reason:'AUTOMATIC_BOUNDARY_UNAVAILABLE'})}
   finally{running=false;if(dirty&&!stopped&&allowed()){queued=true;schedule(drain)}}
  }
  function observe(o){
   if(o?.uncertain===true||o?.transportSettled===false||o?.status==='BINDING_CHANGED'){stopped=true;return}
   if(o?.status!=='ACKNOWLEDGED'||o.transportSettled!==true||!allowed()||stopped)return;
   if(running){dirty=true;return}if(!queued){queued=true;schedule(drain)}
  }
  return Object.freeze({observe,status:()=>({running,queued,stopped}),stop:()=>{stopped=true}});
 }
 return Object.freeze({create});
});
